import type { QueryClient, QueryKey } from "@tanstack/react-query";
import type { AiTaskTarget } from "@workspace/api-client-react";

function apiPath(queryKey: QueryKey): string | null {
  return typeof queryKey[0] === "string" ? queryKey[0].split("?")[0] : null;
}

export function invalidateNotificationTarget(
  queryClient: QueryClient,
  target: AiTaskTarget | null,
  taskId: string,
): void {
  const paths = new Set<string>(["/api/ai-tasks", `/api/ai-tasks/${taskId}`]);
  if (target?.type === "analysis") {
    paths.add("/api/analyses");
    paths.add(`/api/analyses/${target.analysisId}`);
  }
  if (target?.type === "resume-career" || target?.type === "resume-upload" || target?.type === "resume-spellcheck") {
    paths.add("/api/resumes");
    paths.add(`/api/resumes/${target.resumeId}`);
  }
  if (target?.type === "interview") {
    paths.add("/api/interviews");
    paths.add(`/api/interviews/${target.interviewId}`);
  }
  if (target?.type === "companies" || target?.type === "company") paths.add("/api/companies");
  if (target?.type === "company") paths.add(`/api/companies/${target.companyId}`);
  // Cover-letter currently has no result query contract; task list/detail is sufficient.
  void queryClient.invalidateQueries({ predicate: (query) => {
    const path = apiPath(query.queryKey);
    return path !== null && paths.has(path);
  } });
}
